const lang = {
  en: {
    search: "Search",
    gptSearchPlaceHolder: "What would you like to watch today?",
  },
  hi: {
    search: "खोज",
    gptSearchPlaceHolder: "आज आप क्या देखना चाहेंगे?",
  },
};

export default lang;
